const setupFiltersAnnonces = () => {
    const checkboxes = document.querySelectorAll('.terms_list_item-contrats input[type="checkbox"], .terms_list_item-agences input[type="checkbox"], .terms_list_item-secteurs input[type="checkbox"]');
    const resetButtonAnnonces = document.querySelector('#resetAnnoncesButton');
    const loadMoreButton = document.querySelector('#loadMoreAnnonces');
    const gridPostsAnnonces = document.querySelector('.grid_posts-annonces');

    let currentPage = 1;
    let totalPages = 1;

    const checkIfFiltersEmpty = () => {
        const contratsChecked = document.querySelectorAll('.terms_list_item-contrats input[type="checkbox"]:checked').length;
        const secteursChecked = document.querySelectorAll('.terms_list_item-secteurs input[type="checkbox"]:checked').length;
        const agencesChecked = document.querySelectorAll('.terms_list_item-agences input[type="checkbox"]:checked').length;

        if (contratsChecked === 0 && secteursChecked === 0 && agencesChecked === 0) {
            if (resetButtonAnnonces) {
                resetButtonAnnonces.checked = true;
                applyFiltersAndPagination(1, false);
            }
        }
    };

    function updateLoadMoreVisibility(currentPage, totalPages) {
        const loadMoreContainer = loadMoreButton ? loadMoreButton.closest('.load-more-container') : null;
        if (loadMoreContainer) {
            loadMoreContainer.style.display = currentPage < totalPages ? 'block' : 'none';
        }
    }

    const getNoResultsMessage = () => {
        if (typeof ICL_LANGUAGE_CODE !== 'undefined') {
            if (ICL_LANGUAGE_CODE === 'fr') {
                return '<div class="no-results"><b>Actuellement, aucune offre d\'emploi n\'est disponible pour cette agence.</b> <br> N\'hésitez pas à revenir consulter nos opportunités ultérieurement ou à nous envoyer <a href="#form">une candidature spontanée</a>.</div>';
            } else if (ICL_LANGUAGE_CODE === 'en') {
                return '<div class="no-results">No announcements found.</div>';
            }
        }
        return '<div class="no-results"><b>Actuellement, aucune offre d\'emploi n\'est disponible pour cette agence.</b> <br> N\'hésitez pas à revenir consulter nos opportunités ultérieurement ou à nous envoyer <a href="#form">une candidature spontanée</a>.</div>';
    };

    const applyFiltersAndPagination = (page = 1, append = false) => {
        if (typeof ajax_params === 'undefined') {
            console.error('ajax_params is not defined.');
            return;
        }

        const selectedContrats = [];
        const selectedAgences = [];
        const selectedSecteurs = [];

        document.querySelectorAll('.terms_list_item-contrats input[type="checkbox"]:checked').forEach(checkbox => {
            selectedContrats.push(checkbox.value);
        });

        document.querySelectorAll('.terms_list_item-agences input[type="checkbox"]:checked').forEach(checkbox => {
            selectedAgences.push(checkbox.value);
        });

        document.querySelectorAll('.terms_list_item-secteurs input[type="checkbox"]:checked').forEach(checkbox => {
            selectedSecteurs.push(checkbox.value);
        });

        fetch(ajax_params.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                action: 'filter_annonces_pagination',
                page: page,
                contrats: selectedContrats.join(','),
                agences: selectedAgences.join(','),
                secteurs: selectedSecteurs.join(','),
            })
        })
        .then(response => response.json())
        .then(data => {
            if (gridPostsAnnonces) {
                const loadMoreContainer = loadMoreButton ? loadMoreButton.closest('.load-more-container') : null;
                
                if (data.content.trim() === '') {
                    gridPostsAnnonces.innerHTML = getNoResultsMessage();
                    if (loadMoreContainer) {
                        loadMoreContainer.style.display = 'none';
                    }
                } else {
                    if (!append) {
                        gridPostsAnnonces.innerHTML = data.content;
                    } else {
                        gridPostsAnnonces.insertAdjacentHTML('beforeend', data.content);
                    }
                    
                    if (loadMoreContainer) {
                        // Déplacer loadMoreContainer après la grille si ce n'est pas déjà le cas
                        if (loadMoreContainer.nextElementSibling !== gridPostsAnnonces) {
                            gridPostsAnnonces.after(loadMoreContainer);
                        }
                        // Afficher le bouton si il y a plus de pages
                        loadMoreContainer.style.display = data.current_page < data.total_pages ? 'block' : 'none';
                    }
                }
                
                currentPage = data.current_page;
                totalPages = data.total_pages;
            } else {
                console.error('grid_posts-annonces element not found.');
            }
        })
        .catch(error => console.error('Error:', error));
    };

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            if (resetButtonAnnonces) {
                resetButtonAnnonces.checked = false;
            }
            currentPage = 1;
            applyFiltersAndPagination(1, false);
            checkIfFiltersEmpty();
        });
    });

    if (resetButtonAnnonces) {
        resetButtonAnnonces.addEventListener('change', function () {
            if (resetButtonAnnonces.checked) {
                resetFiltersAnnonces();
            } else {
                currentPage = 1;
                applyFiltersAndPagination(1, false);
            }
        });
    }

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', () => {
            currentPage++;
            applyFiltersAndPagination(currentPage, true);
        });
    }

    // Initial check for load more button
    if (loadMoreButton) {
        applyFiltersAndPagination(1, false);
    }
};

const resetFiltersAnnonces = () => {
    const checkboxes = document.querySelectorAll('.terms_list_item-contrats input[type="checkbox"], .terms_list_item-secteurs input[type="checkbox"], .terms_list_item-agences input[type="checkbox"]');

    checkboxes.forEach(checkbox => {
        checkbox.checked = false;
    });

    fetch(ajax_params.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams({
            action: 'filter_annonces_pagination',
            page: 1,
            contrats: '',
            agences: '',
            secteurs: ''
        })
    })
    .then(response => response.json())
    .then(data => {
        const gridPostsAnnonces = document.querySelector('.grid_posts-annonces');
        if (gridPostsAnnonces) {
            if (data.content.trim() === '') {
                gridPostsAnnonces.innerHTML = getNoResultsMessage();
                const loadMoreButton = document.querySelector('#loadMoreAnnonces');
                if (loadMoreButton) {
                    loadMoreButton.closest('.load-more-container').style.display = 'none';
                }
            } else {
                gridPostsAnnonces.innerHTML = data.content;
                const loadMoreButton = document.querySelector('#loadMoreAnnonces');
                if (loadMoreButton) {
                    const loadMoreContainer = loadMoreButton.closest('.load-more-container');
                    // Afficher le bouton si il y a plus de pages
                    loadMoreContainer.style.display = data.total_pages > 1 ? 'block' : 'none';
                }
            }
        } else {
            console.error('grid_posts-annonces element not found.');
        }
    })
    .catch(error => console.error('Error:', error));
};

const applyFiltersAnnonces = () => {
    const resetButtonAnnonces = document.querySelector('#resetAnnoncesButton');
    if (resetButtonAnnonces) {
        resetButtonAnnonces.click();
    }
};

document.addEventListener("DOMContentLoaded", function () {
    setupFiltersAnnonces();
});

export { setupFiltersAnnonces, applyFiltersAnnonces, resetFiltersAnnonces };